var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('textarea',{staticClass:"textarea"}),_c('el-row',{staticClass:"textarea-bottom",attrs:{"type":"flex","justify":"space-between"}},[_c('div',[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconbiaoqing"}})])]),_c('div',[_c('span',{staticClass:"explain"},[_vm._v("还能输入600个字")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }